/* global Plaid */

import { showSuccess, showError } from 'utils/messages';
import EasyPostConstants from 'app/easypost_constants';
import BankAccount from 'app/models/bank_account';
import BankAccountDetailsModal from 'app/views/modals/bank_account_details_modal';

import Base from 'app/views/base';
import tmpl from 'templates/bank_account_button';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .add_account': 'showPlaid',
  },

  initialize(options) {
    this.priority = options.priority;
    this.detailsModal = new BankAccountDetailsModal({
      model: this.model,
      priority: this.priority,
    });
  },

  showPlaid(e) {
    e.preventDefault();
    const self = this;
    const linkHandler = Plaid.create({
      selectAccount: true,
      env: EasyPostConstants.PlaidEnv,
      clientName: 'EasyPost',
      key: EasyPostConstants.PlaidPublicKey,
      product: 'auth',
      onSuccess(publicToken, metadata) {
        self.completePlaidAuth({
          public_token: publicToken,
          account_id: metadata.account_id,
        });
      },
      onExit() {
        self.showDetailsModal();
      },
    });
    linkHandler.open();
  },

  completePlaidAuth(data) {
    const self = this;
    const account = new BankAccount();
    account.save({
      account_id: data.account_id,
      public_token: data.public_token,
      priority: self.priority,
    }, {
      wait: true,
      success(model) {
        self.model.set(`${self.priority}_payment_method`, model);
        showSuccess('Bank account successfully linked to your account.');
      },
      error() {
        showError('The bank account details you provided were not accepted by Plaid');
      },
    });
  },

  showDetailsModal() {
    this.detailsModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/views/bank_account_button_view.js